import { Label } from 'office-ui-fabric-react/lib/Label';
import React from 'react';

import { Resources } from './resources';

interface MonthlyRunsControlProps {
    handleMonthlyRunsChange: (monthlyRunsValue: number) => void;
    monthlyRuns: number;
}

export function MonthlyRunsControl(props: MonthlyRunsControlProps) {
    const handleMonthlyRunsChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        let monthlyRunsValue = e.target.valueAsNumber;
        if (monthlyRunsValue < 1) {
            monthlyRunsValue = 1;
        }
        props.handleMonthlyRunsChange(monthlyRunsValue);
    }

    return (
        <div className="calc-runs-input-container">
            <Label id="monthlyRunsLabel" className="calc-runs-input-label">{Resources.MONTHLY_RUNS_LABEL}</Label>
            <input
                aria-labelledby="monthlyRunsLabel"
                className="calc-runs-input"
                type="number"
                value={props.monthlyRuns}
                onChange={handleMonthlyRunsChange}
            />
        </div>
    );
}